(function (){
  setupToggleDescription();
  national()
})();
/**
 * 展开收起功能函数
 */
function setupToggleDescription(collapsedClass = 'collapsed') {
  const boxes = document.querySelectorAll('.Copywriting0410');
  const buttons = document.querySelectorAll('.toggle-button');
  boxes.forEach((box, index) => {
    const button = buttons[index];
    if (!box || !button) return;
    button.addEventListener('click', function () {
      box.classList.toggle(collapsedClass);
      button.textContent = box.classList.contains(collapsedClass)
        ? 'Read more +'
        : 'Read less -';
    });
  });
}
/**
 * 国旗功能函数
 */
function national(){
  var contry_USAandGE = document.querySelector('.contry_USAandGE');
  var contry_box = document.querySelector('.contry_box');
  var contry_USAandGEList = document.querySelector(
    '.contry_USAandGEList'
  );
  contry_USAandGE.addEventListener('mouseenter', function () {
    contry_USAandGEList.style.display = 'block';
  });
  contry_box.addEventListener('mouseleave', function () {
    contry_USAandGEList.style.display = 'none';
  });
}
/**
 * 电话功能
 */
const box = document.getElementById('box1');
const popupBox = document.getElementById('popupBox12');
const closeBtn12 = document.getElementById('closeBtn12');
box.addEventListener('click', function() {
  popupBox.style.display = 'block';
});
closeBtn12.addEventListener('click', function() {
  popupBox.style.display = 'none';
});